export enum TipoEnvolvimentoEnum {
  NAO_INFORMADO = 0,
  DISTRIBUIDOR = 1,
  FABRICANTE = 2,
}

// Mapeamento para exibição
export const TipoEnvolvimentoLabels: Record<TipoEnvolvimentoEnum, string> = {
  [TipoEnvolvimentoEnum.NAO_INFORMADO]: 'Não informado',
  [TipoEnvolvimentoEnum.DISTRIBUIDOR]: 'Distribuidor',
  [TipoEnvolvimentoEnum.FABRICANTE]: 'Fabricante',
};

// Mapeamento para códigos/slugs
export const TipoEnvolvimentoCodes: Record<TipoEnvolvimentoEnum, string> = {
  [TipoEnvolvimentoEnum.NAO_INFORMADO]: '',
  [TipoEnvolvimentoEnum.DISTRIBUIDOR]: 'O',
  [TipoEnvolvimentoEnum.FABRICANTE]: 'A',
};

export const getTipoEnvolvimentoOptions = () => {
  return Object.values(TipoEnvolvimentoEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value as TipoEnvolvimentoEnum,
      label: TipoEnvolvimentoLabels[value as TipoEnvolvimentoEnum],
      code: TipoEnvolvimentoCodes[value as TipoEnvolvimentoEnum],
    }));
};

export const getTipoEnvolvimentoSlug = (
  tipoEnvolvimento: TipoEnvolvimentoEnum,
): string => {
  return TipoEnvolvimentoCodes[tipoEnvolvimento] || 'Desconhecido';
};

export const getTipoEnvolvimentoLabel = (
  tipoEnvolvimento: TipoEnvolvimentoEnum,
): string => {
  return (
    TipoEnvolvimentoLabels[tipoEnvolvimento] || 'TipoEnvolvimento Desconhecido'
  );
};

export const getTipoEnvolvimentoPorCodigo = (
  code: string,
): TipoEnvolvimentoEnum | undefined => {
  const entry = Object.entries(TipoEnvolvimentoCodes).find(
    ([, value]) => value === code,
  );
  return entry ? (Number(entry[0]) as TipoEnvolvimentoEnum) : undefined;
};

export const getTipoEnvolvimentoLabelPorSlug = (slug: string): string => {
  const tipoEnvolvimento = getTipoEnvolvimentoPorCodigo(slug);

  if (tipoEnvolvimento !== undefined) {
    return getTipoEnvolvimentoLabel(tipoEnvolvimento);
  }

  return 'Tipo de Envolvimento Desconhecido';
};
